import React from 'react';
import { Button, Col, Row, Typography } from 'antd';

import CardArticleLainnya from 'src/components/Card/ArticleLainnya';

import classes from './index.module.less';

const GeneralArticleContainer = (props: any) => {
	return (
		<div style={{ backgroundColor: '#fff' }}>
			<Row>
				<Col md={24} sm={24} xs={24} lg={24} xl={24}>
					<div className={classes.headContact}>
						<Typography className={classes.title}>Artikel Lainnya untuk Mama</Typography>
					</div>
				</Col>
			</Row>

			<Row>
				<Col md={24} sm={24} xs={24} lg={24} xl={24}>
					<CardArticleLainnya data={props.artikelLainnya} />
				</Col>
			</Row>
			<div className={classes.btnFooter}>
				<Button
					className={classes.btn}
					href="/artikel"
					size="large"
					id="detail-artikel-cek-semua-artikel"
				>
					Cek semua artikel
				</Button>
			</div>
		</div>
	);
};

export default GeneralArticleContainer;
